import { Stack } from '@mui/material'
import React from 'react'
import { TAnalyticParams } from '../../shared/types/analyticParameters.type'
import ParamsSection from '../analyticTable/ParamsSection'


type EditConfigProps = {
    loading: boolean,
    groupedParams: Partial<Record<string, TAnalyticParams[]>>,
    selectedParams: TAnalyticParams[],
    pinnedParams: TAnalyticParams[],
    onUpdateParam: (data: TAnalyticParams[]) => void,
    allParams: TAnalyticParams[],
    onParamCheck: (item: TAnalyticParams, checked: boolean) => void,
    isUpdating?: boolean,
    saveSettings: () => void,
    updatePin: (item: TAnalyticParams[]) => void
}

function EditConfig({ loading, groupedParams, pinnedParams, onUpdateParam, isUpdating, saveSettings, allParams, onParamCheck, selectedParams, updatePin }: EditConfigProps) {
    return (
         
            <ParamsSection
              updatePin={updatePin}
              pinnedParams={pinnedParams}
              isUpdating={isUpdating}
              saveSettings={saveSettings}
              onParamCheck={onParamCheck}
              allParams={allParams}
              onUpdateParam={onUpdateParam}
              loading={loading}
              groupedParams={groupedParams}
              selectedParams={selectedParams}></ParamsSection> 
    )
}

export default EditConfig